import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Paper,
  Button,
  Typography,
  FormControlLabel,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import {
  useLocalStorageState,
} from "ahooks";
import useStyles from "@/styles/groupsStyle";
import HasPermission from "@/components/commons/HasPermission";
import SingleSelector from "@/components/SingleSelector";
import SearchInput from "@/components/SearchInput";
import { IconDevices } from "@/components/Icon";
import { FormItem } from "@/components/Form";
import { useTranslation } from "@/langs/useTranslation";
import {useGlobalDispatch} from "@/GlobalProvider";
import { toast } from "@/helpers/toast"
import { useGroupDeviceDispatch, useGroupDeviceState } from "./Provider";
import modalConfirm from "@/components/Modal/modalConfirm";
// 更新状态弹窗
import StoreUpdateStatusModal from "./StoreUpdateStatusModal"
import StoreAccountModal from "./StoreAccountModal"
import StoreSettingModal from  "./StoreSettingModal"
import SelectStoreTreeModal from "./SelectStoreTreeModal"
import ImportStoreDialog from "./Category/Import/ImportDialog";

import _ from "lodash"

import StoreApi from "@/apis/storeAPI"
import localforage from 'localforage';

import StoreTableList from './StoreTableList';
import { downloadBlob } from "@/helpers/utils";
import useUpdatedEffect from 'antd/es/typography/hooks/useUpdatedEffect';

const StoreList = () => {
  const { t, userLanguage } = useTranslation("dashboard");

  const storeLang = useTranslation("store");
  const classes = useStyles();

  const [state,setState ] = useState({
    StoreUpdateStatusModalOpen: false,
    StoreAccountModalOpen: false,
    StoreSettingModalOpen: false
  })


  const [openImportDialog, setOpenImportDialog] = useState(false);
  const [taskSchedule, setTaskSchedule] = useState([]);
  const [crossType, setCrossType] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [loadingTable, setLoadingTable] = useState(null);

  // prettier-ignore
  const { loadingGroup, filterByMode,currentCompanyId,reloadStoreFlag } = useGroupDeviceState();
  const { setShowDetail,reloadCategoryTree } = useGroupDeviceDispatch()

  const { location, push } = useHistory();

  // prettier-ignore
  const initialValues = {
    status: '',
    group_ids: false,
    searchValue: ""
  };
  // 使用 formik 库 https://formik.bootcss.com/api/useFormik.html
  const formik = useFormik({
    initialValues,
    onSubmit: (values) => {
      setCheckedAll(false)
      setSelectedRowKeys([])
      pageSetting.page = 1
      reloadTableData()
    },
    onReset: (values) => {
      pageSetting.page = 1
      // pageSetting.page_size = 20
      pageSetting.order_by_column = null
      pageSetting.order_by_desc = null
      setSelectedRowKeys([])
      setCheckedAll(false)
      setTimeout(()=>{
        reloadTableData('rest')
      },0)
    }
  });

  const importHandler = async () => {
    setOpenImportDialog(true);
  };


  const resetQuery = () => {
    formik.handleReset({
      values: initialValues
    });
  };

  const handleExport = async () => {
    const user_company_id = await localforage.getItem("userCompanyID")
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let param = {
      company_id : currentCompanyId ? currentCompanyId : user_company_id,
      order_by_column: pageSetting.order_by_column,
      order_by_desc: pageSetting.order_by_desc === "ascend" ? "asc" : "desc",
      status: formik.values.status,
      search_value: formik.values.searchValue,
      group_ids: formik.values.group_ids ? formik.values.group_ids : [],
      selectedRowKeys: selectedRowKeys,
      timeZone: timeZone
    }
    const res = await StoreApi.StoreExport(param)
    downloadBlob(res, "store-export.xlsx");
  };

    // 更新状态确认
  const handleStoreUpdateStatusConfirm = async (value) => {
    const res = await StoreApi.UpdateStatus(value,selectedRowKeys)
    if (res && res.status === "success") {
      reloadTableData()
      toast.success(t({ defaultMessage: "操作成功" }));
    }
    setState({
      ...state,
      StoreUpdateStatusModalOpen: false
    })
  }
  // 第一次进入
  useEffect(()=>{
    reloadTableData()
  },[])

  // 修改企业
  useUpdatedEffect(()=>{
    pageSetting.page = 1
    reloadTableData()
  },[currentCompanyId])

  // 某些操作后主动触发刷新
  useUpdatedEffect(()=>{
    reloadTableData()
  },[reloadStoreFlag])



  const reloadTableData = async (type) => {
    const user_company_id = await localforage.getItem("userCompanyID")
    const params = {
      company_id: currentCompanyId ? currentCompanyId : user_company_id,
      page: pageSetting.page,
      page_size: pageSetting.page_size,
      order_by_column: pageSetting.order_by_column,
      order_by_desc: pageSetting.order_by_desc === "ascend" ? "asc" : "desc",
      status: formik.values.status,
      search_value: formik.values.searchValue,
      group_ids: formik.values.group_ids ? formik.values.group_ids : []
    }
    // 重置搜索条件
    if(type==='rest'){
      params.page = 1
      params.status = ''
      params.search_value = ''
      params.group_ids = []
    }
    const res = await StoreApi.GetList(params)
    const data = res.data.list
    setPageSetting({
      ...pageSetting,
      total:res.data.total
    })
    setTotalCount(res.data.total)
    setTableData(data)
    setTableLoading(false)
  }
  // table ref
  const tableRef = useRef(null)
  // 列表多选
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  // table loading
  const [tableLoading, setTableLoading] = useState(true)
  // 数据总数
  const [tableCount,setTableCount] = useState(0)
  // 分页相关
  // const [pageSetting,setPageSetting] = useLocalStorageState("__pageSetting",{
  //   defaultValue: {
  //     page:0,
  //     page_size: 20,
  //     total: 0,
  //     sort:{} // 排序相关
  //   },
  //   listenStorageChange: false
  // })
  const [pageSetting,setPageSetting] = useState(
    {
      page:1,
      page_size: 20,
      total: 0,
      order_by_column: null,// 排序相关
      order_by_desc: null
    },
  )

  // table data
  const [tableData, setTableData] = useState([])

  // 是否全选
  const [checkedAll, setCheckedAll] = useState(false);

  // 排序相关
  // const [tableOrder,setTableOrder] = useState({
  //   order_by_column: pageSetting.sort.order_by_column,
  //   order_by_desc: pageSetting.sort.order_by_desc
  // })

  const tableFunc = {
    // 查看门店配置信息
    handleStoreSetting: (data) => {
      setState({
        ...state,
        StoreSettingModalOpen: true,
        storeInfo: data
      })
    },

    // 查看门店账号信息
    handleStoreAccount: (data) => {
      setState({
        ...state,
        StoreAccountModalOpen: true,
        store_id: data.id
      })
    },
    handleStoreDetail : (data) => {
      setShowDetail(true,data.id,'show')
    },

    handleStoreEdit : (data) => {
      setShowDetail(true,data.id,'edit')
    },

    handleStoreDel : (data) => {
      modalConfirm({
        title: t({ defaultMessage: "提示信息" }),
        content: t({ defaultMessage: "确定要删除吗？" }),
        onConfirm: async () => {
          const user_company_id = await localforage.getItem("userCompanyID")
          StoreApi.Remove(data.id,currentCompanyId ? currentCompanyId : user_company_id).then((res)=>{
            reloadTableData()
            // 刷新左边的分类列表
            reloadCategoryTree()
          })
        }
      });
    },
    // 排序，分页等等
    onChange: (pagination, filters, sorter, extra) => {
      console.log('params', pagination, filters, sorter, extra);
      pageSetting.order_by_column = null
      pageSetting.order_by_desc = null
      if(sorter.column){
        pageSetting.order_by_column = sorter.field
        // pageSetting.order_by_desc = sorter.order === 'descend' ? 'desc' : 'asc'
        pageSetting.order_by_desc = sorter.order
      }
      pageSetting.page = pagination.current
      pageSetting.page_size = pagination.pageSize
      reloadTableData()
    },
    // 多选
    onSelectChange : (newSelectedRowKeys) => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
    // 全选
    handleChangeCheckedAll: async (e) => {
      setCheckedAll(e.target.checked);
      if(!e.target.checked){
        setSelectedRowKeys([])
        return
      }
      // 需要获取到全部的table列表数据
      const user_company_id = await localforage.getItem("userCompanyID")
      const res = await StoreApi.GetList({
        company_id: currentCompanyId ? currentCompanyId : user_company_id,
        page: 1,
        page_size: 9999999,
        order_by_column: "",
        order_by_desc:  "desc",
        status: '',
        search_value: '',
        group_ids: []
      })
      const data = res.data.list
      _.each(data,item=>{
        if(!_.includes(selectedRowKeys,item.id)) {
          selectedRowKeys.push(item.id)
        }
      })
      setSelectedRowKeys(_.cloneDeepWith(selectedRowKeys,true))
    },
    // 删除按钮
    handleDeleteAll : async () => {
      if(selectedRowKeys.length<=0){
        toast.info(t({ defaultMessage: "未选择门店" }));
        return
      }
      modalConfirm({
        title: t({ defaultMessage: "提示信息" }),
        content: t({ defaultMessage: "确定要删除吗？" }),
        onConfirm: async () => {
          const user_company_id = await localforage.getItem("userCompanyID")
          StoreApi.RemoveSome(selectedRowKeys,currentCompanyId ? currentCompanyId : user_company_id).then((res)=>{
            reloadTableData()
            // 刷新左边的分类列表
            reloadCategoryTree()
          })
        }
      });
    },
    // 更新状态弹窗
    handleUpdateStates : () => {
      if(selectedRowKeys.length<=0){
        toast.info(t({ defaultMessage: "未选择门店" }));
        return
      }
      setState({
        ...state,
        StoreUpdateStatusModalOpen: true
      })
    }
  }

  // 导入门店成功 刷新当前页面
  const handleImportSuccess = () => {
    reloadTableData()
  }
  // useEffect(() => {
  //   if (query.size) {
  //     setFilterBy(query.toString());
  //   }
  // }, [location.search]);

  // useUpdateEffect(() => {
  //   if (!filterByMode) {
  //     push(location.pathname);
  //   }
  // }, [filterByMode]);

  // useDebounceEffect(
  //   () => {
  //     if (currentGroup || currentTag || filterBy) {
  //       resetQuery();
  //     }
  //   },
  //   [currentGroup && currentGroup.id, currentTag, filterBy, currentCompanyId],
  //   { wait: 20 }
  // );
  return (
    <div className={classes.main}>
      <div className={`${classes.tableAction} header-btn-box`}>
        <HasPermission permission="merchant_export">
          <Button
            variant="outlined"
            className={`${classes.iconWText} export-btn`}
            onClick={handleExport}
          >
            {t({ defaultMessage: "导出" })}
          </Button>
        </HasPermission>
        <HasPermission permission="merchant_group_import">
          <Button
            variant="outlined"
            className={`${classes.iconWText} import-btn`}
            onClick={() =>
              !loadingGroup && !loadingTable && importHandler()
            }
          >
            {t({ defaultMessage: "汇入门店" })}
          </Button>
        </HasPermission>
      </div>
      <Paper elevation={0} className={classes.deviceInGroup}>
        <form onSubmit={formik.handleSubmit}>
          <FormItem>
            <div className={classes.tableTop}>
              {filterByMode ? (
                <div>
                  <div className={classes.queryKeyword}>
                    <Typography
                      variant="body1"
                      color="textSecondary"
                      component="span"
                    >
                      {t({ defaultMessage: "查询结果：" })}
                    </Typography>
                    <Typography variant="body1" component="span">
                      <IconDevices color="primary" style={{ marginRight: 5 }} />
                      {totalCount}
                      {t({ defaultMessage: "家" })}
                    </Typography>
                  </div>
                  <div className={classes.queryKeyword}>
                    <Typography
                      variant="body1"
                      color="textSecondary"
                      component="span"
                    >
                      {t({ defaultMessage: "查询条件：" })}
                    </Typography>
                    <Typography variant="body1" component="span">
                    </Typography>
                  </div>
                </div>
              ) : (
                <div>
                    <>
                      <span className={classes.groupName}>
                        {t({defaultMessage: "全部门店列表"})}
                      </span>
                      <span className={classes.groupCount}>
                        <IconDevices
                          color="primary"
                          style={{ marginRight: 5 }}
                        />
                        {totalCount}
                        {t({ defaultMessage: "家" })}
                      </span>
                    </>
                </div>
              )}
              {!filterByMode && (
                <SearchInput
                  placeholder={t({ defaultMessage: "搜索" })}
                  name="searchValue"
                  icon={null}
                  disabled={crossType === 2}
                  value={formik.values.searchValue}
                  onChange={formik.handleChange}
                  onPressEnter={formik.handleSubmit}
                />
              )}
            </div>

            <div className={`${classes.tableQueryForm}`}>
              <div className={`store-status-box`}>
                <SingleSelector
                  placeholder={t({ defaultMessage: "选择门店状态" })}
                  options={[
                    { name: t({ defaultMessage: "未开业" }), id: "0" },
                    { name: t({ defaultMessage: "营业" }), id: "1" },
                    { name: t({ defaultMessage: "停业" }), id: "2" },
                    { name: t({ defaultMessage: "闭店" }), id: "3" }
                  ]}
                  clearable
                  disabled={crossType === 2}
                  name="status"
                  initialValue=""
                  value={formik.values.status}
                  onChange={formik.handleChange}
                />
              </div>
              <div className="up-store-box">
                <SelectStoreTreeModal
                  placeHolder={t({ defaultMessage: "选择上层" })}
                  checkStrictly
                  name="group_ids"
                  value={formik.values.group_ids}
                  style={{height: "auto"}}
                  onChange={ formik.handleChange }
                />
              </div>

              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={crossType === 2}
                style={{ marginRight: 16,padding:'6px 16px' }}
              >
                {t({ defaultMessage: "查询" })}
              </Button>
              <Button
                variant="outlined"
                disabled={crossType === 2}
                onClick={() => resetQuery(true)}
              >
                {t({ defaultMessage: "重置" })}
              </Button>
            </div>
          </FormItem>
        </form>
        <div
          className={`${classes.tableWrap} store-table-list paltform-antd-table`}
          style={{ visibility: loadingGroup || loadingTable ? "hidden" : "" }}
        >
          <StoreTableList
            tableLoading={tableLoading}
            pageSetting={pageSetting}
            selectedRowKeys={JSON.parse(JSON.stringify(selectedRowKeys))}
            checkedAll={checkedAll}
            tableData={tableData}
            tableFunc={tableFunc}
          />
        </div>

        <StoreUpdateStatusModal
          open={state.StoreUpdateStatusModalOpen}
          onClose={() => setState({ ...state,StoreUpdateStatusModalOpen: false })}
          onConfirm={handleStoreUpdateStatusConfirm}
        />

        <StoreSettingModal
          open={state.StoreSettingModalOpen}
          rowData={state.storeInfo}
          onClose={() => setState({...state,StoreSettingModalOpen: false})}
        />

        <StoreAccountModal
          storeId={state.store_id}
          open={state.StoreAccountModalOpen}
          onClose={() => setState({...state,StoreAccountModalOpen: false})}
        />

        <ImportStoreDialog
          title={t({defaultMessage: "汇入门店"})}
          open={openImportDialog}
          groupId={""}
          onSuccess={handleImportSuccess}
          onClose={() => setOpenImportDialog(false)}
        />

      </Paper>
    </div>
  );
};

export default StoreList;
